import { render, staticRenderFns } from "./ManagementNav.vue?vue&type=template&id=0c02ab18&scoped=true&"
import script from "./ManagementNav.vue?vue&type=script&lang=js&"
export * from "./ManagementNav.vue?vue&type=script&lang=js&"
import style0 from "./ManagementNav.vue?vue&type=style&index=0&id=0c02ab18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c02ab18",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
